/**
 * Created by wwei on 2017-06-29.
 */
import React, { Component } from "react";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { NavLink } from "react-router-dom";
import { URL } from "../Constants.js";
import Settings from "../Settings.js";
import request from "superagent";
import { signOut } from "../functions/CommonUtils.js";
import SvgIcon from "../../common/components/SvgIcon";
import NewSwitchOrg from "./NewSwitchOrg";

class TopBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserMenu: false
    };
  }

  logoutUser = () => {
    signOut();
  };

  showUserMenu = () => {
    this.setState({ showUserMenu: true });
  };

  hideUserMenu = () => {
    this.setState({ showUserMenu: false });
  };

  showHelpMenu = () => {
    console.log("showing help menu!");
    this.setState({ showHelpMenu: true });
  };

  hideHelpMenu = () => {
    this.setState({ showHelpMenu: false });
  };

  toggleMenu = () => {
    this.props.toggle();
  };

  toChangePwd = () => {
    request
      .put("/api/toChangePwd")
      .send({
        pathname: window.location.pathname
      })
      .withCredentials()
      .end((error, response) => {
        window.location.href = response.body;
      });
  };

  getDisplayName = () => {
    const fname = sessionStorage.getItem("fname");
    const lname = sessionStorage.getItem("lname");
    const email = sessionStorage.getItem("username");
    if (fname || lname) {
      return fname + " " + lname;
    } else {
      return email;
    }
  };

  getHelpMenu = () => {
    if (this.props.featureConfigs.showApiDocsLink) {
      return (
        <li
          className="ts-account"
          onClick={this.showHelpMenu}
          onMouseLeave={this.hideHelpMenu}
          title={this.props.t("COMMON.HELP")}
        >
          <span style={{ float: "right", cursor: "default" }}>
            <SvgIcon name="help_circle_fill" />
          </span>
          <ul
            style={{ top: 50, right: -50 }}
            className={
              (this.state.showHelpMenu ? "show" : "hidden") + " logoutMenu"
            }
          >
            <li>
              <a
                href={Settings.HELP_DOC_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {this.props.t("HELP.PORTAL")}
              </a>
            </li>
            <li>
              <a
                href={this.props.systemConfigs.apiUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {this.props.t("HELP.API")}
              </a>
            </li>
          </ul>
        </li>
      );
    } else {
      return (
        <li className="ts-account">
          <a
            href={Settings.HELP_DOC_URL}
            target="_blank"
            style={{ minWidth: "initial" }}
            rel="help noopener noreferrer"
          >
            <SvgIcon name="help_circle_fill" />
          </a>
        </li>
      );
    }
  };

  render() {
    const { t, showMenuWords, noMenu, title, firstLink } = this.props;
    const companyName = sessionStorage.getItem("companyName")
      ? sessionStorage.getItem("companyName")
      : "";
    const showChangePwd = sessionStorage.getItem("isLocalUser") === "true";

    return (
      <div className="brand clearfix topBar">
        <div className="product-name" style={{ padding: 0 }}>
          {!noMenu && (
            <div
              title={
                showMenuWords ? t("COMMON.HIDE_MENU") : t("COMMON.SHOW_MENU")
              }
              onClick={this.toggleMenu}
              className="left-menu-toggle"
            >
              <SvgIcon name="menu" />
            </div>
          )}
          <div className="logo">
            <NavLink to={URL.ROOT}>
              <img src="/img/logo-full.svg" className="img-responsive" alt="" />
            </NavLink>
          </div>
        </div>
        <div className="product-name">
          <NavLink to={URL.ROOT}>{t("MAIN_TITLE")}</NavLink>
        </div>
        <div className="separator" />
        {title && (
          <div className="product-name">
            <NavLink to={firstLink}>{t(title)}</NavLink>
          </div>
        )}
        <div className="separator" />
        <div className="product-name">
          <NewSwitchOrg
            companyName={companyName}
            history={this.props.history}
          />
        </div>
        <ul className="ts-profile-nav">
          {this.getHelpMenu()}

          <li style={{ textAlign: "center" }} onMouseLeave={this.hideUserMenu}>
            <a
              href="#userMenu"
              style={{ textDecoration: "none", lineHeight: "48px" }}
              onClick={this.showUserMenu}
            >
              <SvgIcon name="account_circle" />
              <div className="topBar-name">{this.getDisplayName()}</div>
            </a>
            <ul
              id="showUserMenu"
              className={`${
                this.state.showUserMenu ? "showUserAvatar" : "hideUserAvatar"
              } logoutMenu`}
            >
              {showChangePwd && (
                <li>
                  <a onClick={this.toChangePwd} id="changePwd">
                    {t("PASSWORD.CHANGE_PASSWORD")}
                  </a>
                </li>
              )}
              <li>
                <a href="/tenant-portal/profile-update" id="updateProfile">
                  {t("USER.ACCOUNT_DETAIL")}
                </a>
              </li>
              <li>
                <a onClick={this.logoutUser} id="logout">
                  {t("USER.LOGOUT")}
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  featureConfigs: state.config.featureConfigs,
  systemConfigs: state.config.systemConfigs
});

export default connect(mapStateToProps)(translate()(TopBar));



// WEBPACK FOOTER //
// ./src/common/struct/TopBar.js